export default {
  COMPUTER: 'computer',
  DROPBOX: 'dropbox',
  GOOGLE_DRIVE: 'google-drive',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  FACEBOOK: 'facebook',
};



// WEBPACK FOOTER //
// ./src/transport/constants/video-sources.js